// extracted by mini-css-extract-plugin
export var chip = "_dn-0";
export var filterDropdown = "_dn-5";
export var filterItem = "_dn-6";
export var icon = "_dn-1";
export var removeButton = "_dn-3";
export var removeIcon = "_dn-4";
export var separator = "_dn-2";